import { Select } from 'antd';
import { useFeatures } from 'utils/features';
import { useGetInspectionTypesQuery } from 'types/atlas-graphql';
import {
  BLADE_INTERNAL_LEGACY,
  TRANSITION_PIECE,
  TOWER_EXTERNAL,
  AUTONOMOUS_DRONE,
  GENERIC,
  GEARBOX_BORESCOPE,
  NACELLE_EXTERNAL,
  EXTERNAL_BLADE_INSPECTION_TYPES,
} from 'utils/constants';
interface Props {
  assetTypeId?: string;
  vendorId?: string;
  onChange: (value: any) => void;
  defaultValue?: string;
  placeholder: string;
  disabled: boolean;
  dropdownStyle?: object;
  onlyExternal?: boolean;
}

export const InspectionTypeChooser = ({
  assetTypeId,
  onChange,
  disabled,
  vendorId,
  onlyExternal,
  ...props
}: Props) => {
  const { features } = useFeatures();

  const filters = [];
  if (assetTypeId) {
    filters.push({ key: 'assetTypeId', values: [assetTypeId || null] });
  }

  if (vendorId) {
    filters.push({ key: 'vendorId', values: [vendorId || null] });
  }
  if (onlyExternal) {
    filters.push({ key: 'name', values: EXTERNAL_BLADE_INSPECTION_TYPES });
  }

  const { data: inspectionTypeData, loading: inspectionTypesLoading } = useGetInspectionTypesQuery({
    variables: {
      filterBy: filters,
    },
    skip: !assetTypeId && !vendorId,
  });

  const dropdownAssetTypes = inspectionTypeData?.inspectionTypes;

  const options = dropdownAssetTypes
    ?.filter(
      ({ name }: { name: string }) =>
        name !== BLADE_INTERNAL_LEGACY &&
        (name !== TRANSITION_PIECE || features['TP_UPLOAD']) &&
        (name !== TOWER_EXTERNAL || features['TOWER_UPLOAD']) &&
        (name !== AUTONOMOUS_DRONE || features['AUTONOMOUS_DRONE_UPLOAD']) &&
        (name !== GENERIC || features['FLEET_MANAGEMENT']) &&
        (name !== GEARBOX_BORESCOPE || features['GEARBOX_BORESCOPE']) &&
        // Nacelle External inspections are always created through ops ingestion. So always hide this option
        name !== NACELLE_EXTERNAL
    )
    .map(({ id, name }: { id: string; name: string }) => ({ label: name, value: id }));

  return (
    <Select
      data-testid="inspection-type-chooser"
      options={options}
      disabled={disabled}
      loading={inspectionTypesLoading}
      onChange={onChange}
      {...props}
    />
  );
};
